/**
 * API клиент для загрузки метаданных фильтрации
 */

import { rest } from "src/common/rest";

import {
  ZFilterMetadataResponse,
  zFilterMetadataResponse,
} from "../types/ZFilterMetadataTypes";

export type ZFilterMetadataLoader = () => Promise<ZFilterMetadataResponse>;

const loadFilterMetadataByUrl = async (
  url: string,
): Promise<ZFilterMetadataResponse> => {
  const response = await rest.get(url);
  return zFilterMetadataResponse.parse(response.data);
};

export const loadCatalogFilterMetadata = async (
  catalogId: string,
): Promise<ZFilterMetadataResponse> => {
  const url = `/api/core/catalogs/cards/${catalogId}/filter-info`;
  return loadFilterMetadataByUrl(url);
};

export const loadClassFilterMetadata = async (
  classId: string,
): Promise<ZFilterMetadataResponse> => {
  const url = `/api/v1/core/classes/${classId}/filter-info`;
  return loadFilterMetadataByUrl(url);
};
